import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  personalBrandingIcon,
  seoMarketingIcon,
  payPerClickIcon,
  emailMarketinIcon,
  influencerMarketingIcon,
  analyticIcon,
} from "../../../../assets/icons/serviceIcon/index";
import SocialMediaMarketingWork from "./SocialMediaMarketingWork";
import { useEffect } from "react";

const items = [
  {
    name: "Content Strategy & Planning",
    text: "We plan what to post, when to post and how to make it connect with your audience.",
  },
  {
    name: "Creative Design & Captions",
    text: "From eye-catching visuals to scroll-stopping words, we make your brand look and sound its best.",
  },
  {
    name: "Page Management & Engagement",
    text: "We manage your account, respond to comments, and build real relationships with your followers.",
  },
];

const otherService = [
  {
    icon: seoMarketingIcon,
    name: "Seo & Content Marketing",
    des: "Get ranked on Google and stay in hearts with content that truly speaks to your people.",
    path: "/seo-content-marketing",
  },
  {
    icon: personalBrandingIcon,
    name: "personal Branding",
    des: "Turn your story, skills, and personality into something people remember and trust.",
    path: "/personal-branding",
  },
  {
    icon: payPerClickIcon,
    name: "Pay Per Click",
    des: "Get your brand seen by the right people, right when they’re searching for you.",
    path: "/pay-per-click",
  },
  {
    icon: emailMarketinIcon,
    name: "Email & CRM Marketing",
    des: "Stay in touch in a meaningful way with emails people actually want to open.",
    path: "/email-marketing",
  },
  {
    icon: influencerMarketingIcon,
    name: "Influencer & Affiliate Marketing",
    des: "Let others talk about your brand in a way that feels real and relatable.",
    path: "/influencer-marketing",
  },
  {
    icon: analyticIcon,
    name: "Analytics  & Performance Tracking ",
    des: "Know what’s working, what’s not, and what to do next without the guesswork.",
    path: "/analytic-and-performance-tracking",
  },
];

const SocialMediaMarketing = () => {
  useEffect(() => {
    // Set Page Title
    document.title = "Social Media Marketing Services | TechQilla";

    // --- Description ---
    let metaDescription = document.querySelector<HTMLMetaElement>(
      "meta[name='description']",
    );
    if (!metaDescription) {
      metaDescription = document.createElement("meta");
      metaDescription.name = "description";
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute(
      "content",
      "Grow your brand with data-driven social media marketing services. TechQilla manages content, ads, and engagement across platforms",
    );

    // --- Keywords ---
    let metaKeywords = document.querySelector<HTMLMetaElement>(
      "meta[name='keywords']",
    );
    if (!metaKeywords) {
      metaKeywords = document.createElement("meta");
      metaKeywords.name = "keywords";
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.setAttribute(
      "content",
      "Social Media Marketing Services",
    );
    // --- Canonical ---
    let linkTag = document.querySelector<HTMLLinkElement>(
      "link[rel='canonical']",
    );
    if (!linkTag) {
      linkTag = document.createElement("link");
      linkTag.rel = "canonical";
      document.head.appendChild(linkTag);
    }
    linkTag.setAttribute(
      "href",
      "https://www.techqilla.com/social-media-marketing",
    );
  }, []);

  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Marketing"
        description="Social media isn’t just about posting,  it’s about building a vibe people want to be part of. From your first impression to everyday engagement, we help you show up with purpose, personality, and consistency."
        heading="Social Media"
      />
      <NewCommonServiceForm title="Social Media Marketing" items={items} />
      <SocialMediaMarketingWork />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default SocialMediaMarketing;
